import axiosInstance from "services/AxiosInstance";
import { ResponseType } from "types";

import { CustomField } from "../types";

export const getCustomFields = async (accountId: string): Promise<ResponseType<CustomField[]>> => {
  const response = await axiosInstance.get(`/customfields/account/${accountId}`);
  return response.data;
};
